var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Eye",
    transform: "translate(0.5)",
    opacity: 0.54
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4929",
    "data-name": "Group 4929",
    transform: "translate(-695 -387)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4867",
    "data-name": "Group 4867",
    transform: "translate(215.5 -194.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4865",
    "data-name": "Group 4865",
    transform: "translate(479.5 584.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_2",
    "data-name": "Union 2",
    d: "M-6635-204.279c0-1.565,3.117-6.721,10-6.721s10,5.155,10,6.721-3.117,6.722-10,6.722S-6635-202.714-6635-204.279Zm.984,0c0,1.177,2.8,5.738,9.017,5.738s9.016-4.561,9.016-5.738-2.8-5.736-9.016-5.736-9.017,4.561-9.017,5.736Z",
    transform: "translate(6635 211)",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4866",
    "data-name": "Group 4866",
    transform: "translate(485.402 587.123)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1826",
    "data-name": "Path 1826",
    d: "M501.6,600.7a4.1,4.1,0,1,1,4.1-4.1A4.1,4.1,0,0,1,501.6,600.7Zm0-7.213a3.115,3.115,0,1,0,3.115,3.115A3.118,3.118,0,0,0,501.6,593.484Z",
    transform: "translate(-497.5 -592.5)"
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1645",
    "data-name": "Rectangle 1645",
    width: 20,
    height: 20,
    transform: "translate(695 387)",
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/Eye.3f4d62a5c499197237cc210540052e46.svg";
export { ForwardRef as ReactComponent };